import api from "../../client";
import { UpdatePeopleTagsPayload } from "../../types/people";
import { Status } from "../../types/status";

export const updatePeopleTagsRequest = async (
  id: string,
  payload: UpdatePeopleTagsPayload,
): Promise<Status> => {
  const { data } = await api.put<Status>(`/profile/${id}/tags`, payload);

  return data;
};
